module.exports = __webpack_public_path__ + "img/horizontal_7_3_pp3_7042.de38a51c.png";